import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import AuthenticationConfigurationStore
    from '../../stores/AuthenticationConfigurationSSO/AuthenticationConfigurationStore';
import { ConsoleCard, FuseConsoleCardFooter } from '../ConsoleFragments';
import { FTHeading, FTBody } from '../Fuse/Text';
import FuseConsoleModal from '../ConsoleModal/FuseConsoleModal';
import FuseButton from '../FuseControls/FuseButton';
import FuseTextfield from '../FuseControls/FuseTextfield';
import FuseAlert from '../FuseControls/FuseAlert';
import SnackStore from '../../stores/SnackStore';
import copyText from '../../copyText';

import './KeyCreateModal.css';

const block = b.lock('KeyCreateModal');

class KeyCreateModal extends Component {
    static propTypes = {
        authenticationConfiguration: AuthenticationConfigurationStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    copyApiKey = (text, itemName) => {
        if (copyText(text)) {
            this.props.snack.showSuccess(`${itemName} has been copied to clipboard`);
        } else {
            this.props.snack.showError('Unable to copy');
        }
    };

    render() {
        const { authenticationConfiguration } = this.props;
        const { createStore } = authenticationConfiguration;
        return <FuseConsoleModal
            large
            isOpen={authenticationConfiguration.createModal.isOpen}
            onClose={authenticationConfiguration.onCloseCreateModal}
            greyBackground
            hideCloseButton
            title="SCIM API Key Created"
            subTitle="- Users Provisioning and Group Synchronization"
            headerActions={<FuseButton
                type={'primary'}
                color={'blue'}
                onClick={authenticationConfiguration.onCloseCreateModal}
            >Close</FuseButton>}
        >
            <ConsoleCard className={block('Section')}>
                <FTHeading>Summary</FTHeading>
                <FuseAlert
                    title="WARNING - "
                    subtitle="you will no longer have access to the SCIM API Key Secret after you close this window.
                              To obtain a new secret you must delete your current SCIM API Key and generate a new one."
                    type="warning"
                    className={block('Field')}
                />
                <div className={block('ConsoleFieldWrapper')}>
                    <FuseTextfield
                        store={createStore.apiKey}
                        label="SCIM API Key"
                        leftIcon={'key'}
                        className={block('TextField')}
                        disabled
                    />
                    <FuseButton
                        type={'tertiary'}
                        color={'blue'}
                        icon={'assignment'}
                        className={block('UrlsButton')}
                        onClick={() => this.copyApiKey(createStore.apiKey.value, 'API Key ID')}
                    > <FTBody className={block('UrlsButtonText')}>Copy to clipboard</FTBody> </FuseButton>
                </div>
                <div className={block('ConsoleFieldWrapper')}>
                    <FuseTextfield
                        store={createStore.secret}
                        label="Secret"
                        className={block('TextField')}
                        disabled
                    />
                    <FuseButton
                        type={'tertiary'}
                        color={'blue'}
                        icon={'assignment'}
                        className={block('UrlsButton')}
                        onClick={() => this.copyApiKey(createStore.secret.value, 'Secret')}
                    > <FTBody className={block('UrlsButtonText')}>Copy to clipboard</FTBody> </FuseButton>
                </div>
                <FuseConsoleCardFooter
                    className={block('Footer')}
                    text={'Secret can only be copied to the clipboard when the SCIM API Key is first created.'}
                />
            </ConsoleCard>
        </FuseConsoleModal>;
    }
}
export default inject('authenticationConfiguration', 'snack')(observer(KeyCreateModal));
